import { isWebView } from 'shared/helpers/utils/url';
import { getDeviceType, DEVICE_TYPE } from 'shared/helpers/app';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

export const GRAHAK_AUTH_SURFACE = {
  DWEB: 'dweb',
  MWEB: 'mweb',
  WEBVIEW: 'webview',
} as const;

export type GrahakAuthSurface = (typeof GRAHAK_AUTH_SURFACE)[keyof typeof GRAHAK_AUTH_SURFACE];

const isDesktopSurface = () => getDeviceType() === DEVICE_TYPE.DESKTOP;

const isCurrentlyWebView = () => typeof window !== 'undefined' && isWebView(window.location as any);

export const getGrahakAuthSurfaceFromState = (state?: any): GrahakAuthSurface | null => {
  const grahakAuthConfig = state ? getRemoteConfig(state, 'grahakAuth') : undefined;

  const {
    onlyEnableForDweb = false,
    onlyEnableForMweb = false,
    enableForWebView = false,
  } = grahakAuthConfig || {};

  if (isCurrentlyWebView()) {
    return enableForWebView ? GRAHAK_AUTH_SURFACE.WEBVIEW : null;
  }

  if (isDesktopSurface()) {
    return onlyEnableForDweb ? GRAHAK_AUTH_SURFACE.DWEB : null;
  }

  return onlyEnableForMweb ? GRAHAK_AUTH_SURFACE.MWEB : null;
};

export const isEligibleforGrahakRuleFromState = (state?: any) =>
  getGrahakAuthSurfaceFromState(state) !== null;
